/*
  Livvi header, redesign stap 6. Geladen door sections/lv-header.liquid (defer).
  - Megamenu: klik of hover (desktop) opent één paneel; Esc, klik buiten en Tab weg sluiten het.
  - Uitschuifmenu op mobiel met focus in het paneel en scroll-lock.
  - Zoeksuggesties via de Shopify predictive search (sectie lv-predictive-search), 200 ms vertraging.
  - Bij omlaag scrollen verdwijnt de logo-en-zoekregel, bij omhoog scrollen komt hij vast bovenaan;
    zolang de sticky koopbalk (.lv-sticky.is-visible) in beeld is blijft hij weg.
  - Winkelwagen-aantal: verberg het bolletje bij 0, ook nadat het thema de inhoud heeft vervangen.
*/
(function () {
  var header = document.querySelector('[data-lv-header]');
  if (!header) return;
  var desktop = window.matchMedia('(min-width: 1025px)');

  /* ---------- megamenu ---------- */
  var toggles = Array.prototype.slice.call(header.querySelectorAll('[data-lv-mega-toggle]'));
  var hoverTimer = null;
  function closeAll(except) {
    toggles.forEach(function (t) {
      if (t === except) return;
      t.setAttribute('aria-expanded', 'false');
      var p = document.getElementById(t.getAttribute('aria-controls'));
      if (p) p.hidden = true;
    });
  }
  function open(t) {
    closeAll(t);
    t.setAttribute('aria-expanded', 'true');
    var p = document.getElementById(t.getAttribute('aria-controls'));
    if (p) p.hidden = false;
  }
  toggles.forEach(function (t) {
    var item = t.parentElement;
    t.addEventListener('click', function () {
      if (t.getAttribute('aria-expanded') === 'true') closeAll(); else open(t);
    });
    item.addEventListener('mouseenter', function () {
      if (!desktop.matches) return;
      clearTimeout(hoverTimer);
      hoverTimer = setTimeout(function () { open(t); }, 120);
    });
    item.addEventListener('mouseleave', function () {
      if (!desktop.matches) return;
      clearTimeout(hoverTimer);
      hoverTimer = setTimeout(function () { closeAll(); }, 180);
    });
    item.addEventListener('focusout', function (e) {
      if (!item.contains(e.relatedTarget)) {
        t.setAttribute('aria-expanded', 'false');
        var p = document.getElementById(t.getAttribute('aria-controls'));
        if (p) p.hidden = true;
      }
    });
  });
  document.addEventListener('click', function (e) {
    if (!e.target.closest('.lv-nav')) closeAll();
  });

  /* ---------- uitschuifmenu ---------- */
  var drawer = header.querySelector('[data-lv-menu-drawer]');
  var burger = header.querySelector('[data-lv-menu-open]');
  function openDrawer() {
    drawer.hidden = false;
    document.documentElement.classList.add('lv-no-scroll');
    burger.setAttribute('aria-expanded', 'true');
    requestAnimationFrame(function () { drawer.classList.add('is-open'); });
    var first = drawer.querySelector('button, a, summary');
    if (first) first.focus();
  }
  function closeDrawer() {
    drawer.classList.remove('is-open');
    document.documentElement.classList.remove('lv-no-scroll');
    burger.setAttribute('aria-expanded', 'false');
    setTimeout(function () { drawer.hidden = true; }, 200);
    burger.focus();
  }
  if (drawer && burger) {
    burger.addEventListener('click', openDrawer);
    drawer.querySelectorAll('[data-lv-menu-close]').forEach(function (b) { b.addEventListener('click', closeDrawer); });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (drawer && !drawer.hidden) closeDrawer();
    closeAll();
    closePs();
  });

  /* ---------- zoeksuggesties ---------- */
  /* Elke zoekbalk met [data-lv-search-wrap] krijgt suggesties: de header en sinds 19 oktober de zoekhero op de homepage */
  var url = (window.routes && window.routes.predictive_search_url) || '/search/suggest';
  var psList = [];
  function closePs() {
    psList.forEach(function (ps) { ps.panel.hidden = true; ps.input.setAttribute('aria-expanded', 'false'); });
  }
  function setupPs(wrap, n) {
    var input = wrap.querySelector('input[type="search"]');
    var panel = wrap.querySelector('[data-lv-ps]');
    if (!input || !panel) return;
    var psTimer = null;
    var psCtrl = null;
    var ps = { input: input, panel: panel };
    psList.push(ps);
    function fetchPs(q) {
      if (psCtrl) psCtrl.abort();
      psCtrl = 'AbortController' in window ? new AbortController() : null;
      var params = 'q=' + encodeURIComponent(q) +
        '&section_id=lv-predictive-search' +
        '&resources%5Btype%5D=product,collection' +
        '&resources%5Blimit%5D=6' +
        '&resources%5Boptions%5D%5Bunavailable_products%5D=last' +
        '&resources%5Boptions%5D%5Bfields%5D=title,vendor,product_type,tag';
      fetch(url + '?' + params, psCtrl ? { signal: psCtrl.signal } : {})
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var res = doc.querySelector('[data-lv-ps-result]');
          if (!res || input.value.trim() !== q) return;
          panel.innerHTML = '';
          panel.appendChild(res);
          panel.hidden = false;
          input.setAttribute('aria-expanded', 'true');
        })
        .catch(function () {});
    }
    var panelId = n === 0 ? 'lv-ps-panel' : 'lv-ps-panel-' + n;
    input.setAttribute('aria-controls', panelId);
    input.setAttribute('aria-expanded', 'false');
    panel.id = panelId;
    input.addEventListener('input', function () {
      var q = input.value.trim();
      clearTimeout(psTimer);
      if (q.length < 2) { panel.hidden = true; input.setAttribute('aria-expanded', 'false'); return; }
      psTimer = setTimeout(function () { fetchPs(q); }, 200);
    });
    input.addEventListener('focus', function () {
      if (input.value.trim().length >= 2 && panel.innerHTML) panel.hidden = false;
    });
    document.addEventListener('click', function (e) {
      if (!wrap.contains(e.target)) { panel.hidden = true; input.setAttribute('aria-expanded', 'false'); }
    });
  }
  Array.prototype.forEach.call(document.querySelectorAll('[data-lv-search-wrap]'), setupPs);

  /* ---------- vaste regel bij omhoog scrollen ---------- */
  var main = header.querySelector('[data-lv-header-main]');
  var slot = header.querySelector('[data-lv-header-slot]');
  var lastY = window.scrollY;
  var ticking = false;
  function onScroll() {
    var y = window.scrollY;
    var start = slot.getBoundingClientRect().bottom + y + 200;
    var stickyBuy = document.querySelector('.lv-sticky.is-visible');
    if (y < start || stickyBuy) {
      main.classList.remove('is-fixed', 'is-shown');
      slot.style.removeProperty('min-height');
    } else {
      if (!main.classList.contains('is-fixed')) {
        slot.style.minHeight = main.offsetHeight + 'px';
        main.classList.add('is-fixed');
      }
      main.classList.toggle('is-shown', y < lastY);
      if (y > lastY) { closeAll(); closePs(); }
    }
    lastY = y;
    ticking = false;
  }
  window.addEventListener('scroll', function () {
    if (!ticking) { ticking = true; requestAnimationFrame(onScroll); }
  }, { passive: true });

  /* ---------- winkelwagen-aantal ----------
     Het thema werkt het bolletje alleen bij via zijn eigen toevoegknop. Kaching, aantallen in de drawer en
     andere apps wijzigen de winkelwagen via de cart-API zonder dat. Daarom: na elke cart-aanroep, bij het laden
     en bij terugnavigeren (bfcache) het echte aantal uit /cart.js halen (fix 20 oktober 2026). */
  var bubble = document.getElementById('cart-icon-bubble');
  var root = (window.routes && window.routes.cart_url ? window.routes.cart_url.replace(/cart$/, '') : '/');
  function setCount(n) {
    var c = bubble && bubble.querySelector('.cart-count');
    if (!c) return;
    var txt = n > 99 ? '99+' : String(n);
    if (c.textContent.trim() !== txt) c.textContent = txt;
    c.classList.toggle('is-empty', n === 0);
  }
  function syncCount() {
    var c = bubble && bubble.querySelector('.cart-count');
    if (!c) return;
    var n = parseInt((c.textContent || '0').replace(/\D/g, ''), 10) || 0;
    c.classList.toggle('is-empty', n === 0);
  }
  var refreshTimer = null;
  function refreshCount() {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(function () {
      origFetch(root + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) { if (cart && typeof cart.item_count === 'number') setCount(cart.item_count); })
        .catch(function () {});
    }, 250);
  }
  var cartPad = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  var origFetch = window.fetch.bind(window);
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = origFetch(input, init);
    if (cartPad.test(url)) { p.then(refreshCount, refreshCount); }
    return p;
  };
  var origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (cartPad.test(String(url || ''))) { this.addEventListener('loadend', refreshCount); }
    return origOpen.apply(this, arguments);
  };
  ['cart:updated', 'cart:refresh', 'cart:change'].forEach(function (ev) { document.addEventListener(ev, refreshCount); });
  window.addEventListener('pageshow', refreshCount);
  /* Zelfcorrigerend (19 oktober): overschrijft het thema, de drawer of een app het getal (bijvoorbeeld met het
     aantal regels in plaats van het aantal stuks), dan halen we direct het echte aantal uit /cart.js.
     Geen lus: setCount wijzigt alleen als het getal afwijkt. */
  if (bubble && 'MutationObserver' in window) {
    new MutationObserver(function () { syncCount(); refreshCount(); }).observe(bubble, { childList: true, subtree: true, characterData: true });
  }
  window.addEventListener('focus', refreshCount);
  document.addEventListener('visibilitychange', function () { if (!document.hidden) refreshCount(); });
  refreshCount();
})();
